import React from 'react';
import { connect } from 'react-redux';
import Main from './Main';
import Login from './components/login';
import './App.css';

const App = props => {
  const {isLoggedIn} = props

  return (
    <div style={styles.appContainerStyle}>
      {isLoggedIn ? <Main /> : <Login />}
    </div>
  );
}

const mapStateToProps = (state) => {
  const {isLoggedIn} = state.auth
  return {isLoggedIn}
}
export default connect(mapStateToProps)(App)

const styles = {
  appContainerStyle: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    margin: 0,
    overflow: 'hidden',
    backgroundColor: 'rgba(10,14,25,0.7)',
  }
}